module.exports = __webpack_public_path__ + "static/media/pic3.610780c4.webp";